var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_11170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1316 3.75157C45.321 2.045 41.2981 0.834293 37.1658 0.150391C36.6003 1.13921 36.0886 2.15658 35.633 3.19823C31.2312 2.5494 26.755 2.5494 22.3533 3.19823C21.8973 2.15669 21.3857 1.13933 20.8205 0.150391C16.6855 0.840069 12.66 2.05365 8.84548 3.7605C1.27273 14.7202 -0.780129 25.4078 0.246299 35.9436C4.68109 39.1487 9.64489 41.5863 14.9219 43.1504C16.1102 41.5871 17.1616 39.9287 18.0651 38.1926C16.349 37.5657 14.6928 36.7922 13.1154 35.8811C13.5306 35.5866 13.9366 35.2831 14.3289 34.9886C18.9186 37.1 23.928 38.1947 29 38.1947C34.0719 38.1947 39.0813 37.1 43.671 34.9886C44.0679 35.3054 44.4739 35.6089 44.8845 35.8811C43.3041 36.7937 41.6448 37.5686 39.9257 38.1971C40.8281 39.9323 41.8796 41.5894 43.0689 43.1504C48.3504 41.5926 53.318 39.1562 57.7536 35.948C58.958 23.7299 55.6962 13.1405 49.1316 3.75157ZM19.3652 29.4641C16.5049 29.4641 14.1418 26.925 14.1418 23.8013C14.1418 20.6776 16.4228 18.1161 19.3561 18.1161C22.2894 18.1161 24.6342 20.6776 24.584 23.8013C24.5339 26.925 22.2803 29.4641 19.3652 29.4641ZM38.6347 29.4641C35.7698 29.4641 33.4159 26.925 33.4159 23.8013C33.4159 20.6776 35.6968 18.1161 38.6347 18.1161C41.5726 18.1161 43.8991 20.6776 43.8489 23.8013C43.7988 26.925 41.5497 29.4641 38.6347 29.4641Z",
    fill: "#5865F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_11170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 43,
    fill: "white",
    transform: "translate(0 0.150391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord_logo.67c6e883191f11f30eba002533300d94.svg";
export { ForwardRef as ReactComponent };